import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-dlg-editar-cuenta',
  templateUrl: './dlg-editar-cuenta.component.html',
  styleUrls: ['./dlg-editar-cuenta.component.scss']
})
export class DlgEditarCuentaComponent implements OnInit {

  grupoVal = new FormGroup({
    CUENTA: new FormControl('', [Validators.required, Validators.minLength(12), Validators.maxLength(12), Validators.pattern(/^\d{12}$/)])
  });

  cuentaAnterior: string = '';
  guardando: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DlgEditarCuentaComponent>,
    private gateway: GatewayService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit() {
    this.cuentaAnterior = this.data.cita.cuenta || '';
    this.grupoVal.controls.CUENTA.setValue(this.cuentaAnterior);
  }

  guardar() {
    if (this.grupoVal.invalid || this.guardando) return;

    const cuentaNueva = this.grupoVal.controls.CUENTA.value.trim();
    if (cuentaNueva === this.cuentaAnterior) {
      this.snackbar.open('La cuenta no ha cambiado.', 'Cerrar', { duration: 3000 });
      return;
    }

    this.guardando = true;
    const user = this.localSave.get('usuarioPGV');
    const nombre = this.localSave.get('userLoggedIn') || '';
    const correo = this.localSave.get('email') || '';

    this.gateway.save('editarcuentacita', {
      IDCITA: this.data.cita.id,
      CUENTA_NUEVA: cuentaNueva,
      CUENTA_ANTERIOR: this.cuentaAnterior,
      ID_CLIENTE: this.data.cita.id_client || null,
      ORDEN: this.data.cita.numero_orden || null,
      IDUSUARIO: user.IDU,
      NOMBRE: nombre,
      CORREO: correo
    }).then((result: any) => {
      this.guardando = false;
      if (result.response === 1) {
        this.snackbar.open('Cuenta actualizada correctamente.', 'Cerrar', { duration: 3000 });
        this.dialogRef.close(true);
      } else {
        this.snackbar.open(result.msgerror || 'Error al actualizar.', 'Cerrar', { duration: 3000 });
      }
    }).catch(() => {
      this.guardando = false;
      this.snackbar.open('Error al actualizar la cuenta.', 'Cerrar', { duration: 3000 });
    });
  }

  soloDigitos(event: any) {
    const valor = event.target.value.replace(/[^0-9]/g, '');
    this.grupoVal.controls.CUENTA.setValue(valor);
  }

  cancelar() {
    this.dialogRef.close(false);
  }
}
